import Backbone from 'backbone';
import * as AnalyticAppColor from 'common/constants/analytic-app-color';
import {isValid} from 'common/utils/number-util';

const AvatarOrbView = Backbone.View.extend({
  getColor(systemName) {
    const collection = this.intensityReportCollection;
    const intensity = collection.getIntensity(systemName);
    if (isValid(intensity)) {
      const colors = [
        // Green
        '#6CBD44',

        // Light green
        '#B3D45F',

        // Yellow
        '#FED25D',

        // Orange
        '#F79837',

        // Red
        '#E2664C',
      ];
      const indexes = colors.length - 1;
      let index = Math.round(indexes * intensity);
      if (index < 0) {
        index = 0;
      }
      if (index > indexes) {
        index = indexes;
      }
      return colors[index];
    }
    return AnalyticAppColor.WHITE.primary;
  },

  initialize(options) {
    const collections = options.collections;
    this.facilityCollection = collections.facilityCollection;
    this.intensityReportCollection = collections.intensityReportCollection;
    this.orb_enabled = false;
    this.photo_enabled = false;
    this.photo_rendered = false;
    const configuration = options.settings.configuration;
    if (configuration) {
      if (configuration.orb_b) {
        this.orb_enabled = true;
      }
      if (configuration.photo_b) {
        this.photo_enabled = true;
      }
    }
    this.initOrb(this.orb_enabled, this.photo_enabled);
  },

  initOrb(orb_enabled, photo_enabled) {
    if (orb_enabled) {
      this.$el.attr('class', 'avatar-orb');
    } else if (!photo_enabled) {
      this.$el.css('display', 'none');
      $('.spacer-avatar-orb').attr('class', 'spacer-none');
    }
  },

  render(point) {
    if (this.photo_enabled) {
      this.renderPhoto();
    }
    if (this.orb_enabled) {
      this.renderOrb(point);
    }
  },

  renderOrb(systemName) {
    const color = this.getColor(systemName);
    this.$el.css('background-color', color);
    this.$el.css('border-color', color);
  },

  renderPhoto() {
    if (!this.photo_rendered) {
      const facility = this.facilityCollection.getFacility();
      const profile = facility.images.profile;
      this.$el.css('background-image', `url(${profile})`);
    }
  },
});

export default AvatarOrbView;
